import gql from "graphql-tag";

export const DELETE_TEMPLATE_COSTUME_VALUE = gql`
  mutation DeleteCostumeValue($filter: UniqCostumeValueFilterInput!) {
    deleteCostumeValue(filter: $filter) {
      id
    }
  }
`;
